import axios from "axios";
import qs from "qs";
import APP from "./appConfig";
import {Loading} from "element-ui";
import {getToken} from "./utils/auth"; // getToken from cookie
import router from "@/router";
import {localization} from "@/common/lang/localization";
import store from "@/store";
import {navigationPaths} from "@/common/navigation/navigationPaths";

const ERROR_REDIRECT = "ERROR_REDIRECT";

// development  测试环境
//

/* 一些请求的全局配置 */
let loadingInstance;
// let Loading = ELEMENT.Loading
axios.interceptors.request.use(config => {
    config.url = APP.DOMAIN + config.url;
    config.headers = {
        "TB-Source": "vue",
        ...config.headers
    }

    return config;
});

axios.interceptors.response.use(
    response => {
        checkFrontendVersion(response);

        if (response.status === 200) {
            return response
        } else {
            Promise.reject(response.data.message)
        }
    },
    error => {
        checkFrontendVersion(error.response);

        if (error.response) {
            if (error.response.status === 401) {
                router.push(navigationPaths.login.base).catch(() => {});
                return Promise.reject(ERROR_REDIRECT)
            } else if (error.response.status === 403) {
                if (error.response.data.externalRedirectUrl) {
                    store.dispatch("setRedirect", {
                        name: error.response.data.externalRedirectName,
                        url: error.response.data.externalRedirectUrl
                    });
                    router.push(navigationPaths.redirect).catch(() => {});
                    return Promise.reject(ERROR_REDIRECT);
                } else if (router.history.current.path === navigationPaths.login.base) {
                    return Promise.reject(error.response.data);
                }

                router.replace(navigationPaths.accessDenied).catch(() => {});
                return Promise.reject(ERROR_REDIRECT);
            } else {
                return Promise.reject(error.response.data)
            }
        }

        return Promise.reject(error.response.data)
    }
)
axios.defaults.timeout = 60000;
axios.defaults.withCredentials = true;

/* GET请求 */
function GET(url, params, showLoading = true) {
    var option = {
        ...params
    };
    // url = url + fiterParams(realParam);
    if (showLoading) {
        loadingInstance = Loading.service();
    }
    return axios
        .get(url, {
            params: option,
            headers: {
                "SameSite": "None",
                "x-xsrf-token": getToken(),
            }
        })
        .then(reqResult)
        .catch(reqErr);
}
/* POST请求 */
function POST(url, params, contentType = "application/json", type = '', isDownloadingFile = false) {
    loadingInstance = Loading.service();
    let option = {
        ...params
    }
    if (type && (type === 'Array' || type === 'String')) {
        option = params
    }
    return axios
        .post(
            url, option, {
                headers: {
                    "Content-Type": contentType,
                    // "x-xsrf-token": getToken()
                },
                ...(isDownloadingFile ? { responseType: "blob" } : {})
            }
        )
        //isDownloadingFile is used to make a POST request expecting a file download. On the java side, the response is a ResponseEntity<ByteArray>
        .then(isDownloadingFile? download : reqResult)
        .catch(reqErr);
}


function Delete(url, params, contentType = "application/json", type = '') {
    let option = {
        ...params
    }
    if (type && type == 'Array') {
        option = params
    }
    loadingInstance = Loading.service();
    return axios
        .delete(
            url, {
                data: option,
                headers: {
                    "Content-Type": contentType,
                    // "x-xsrf-token": getToken()
                }
            }
        )
        .then(reqResult)
        .catch(reqErr);
}
/* PUT */
function PUT(url, params, contentType = "application/json") {
    loadingInstance = Loading.service();
    return axios
        .put(
            url, {
                ...params
            }, {
                headers: {
                    "Content-Type": contentType,
                    // "x-xsrf-token": getToken()
                }
            }
        )
        .then(reqResult)
        .catch(reqErr);
}

function FormPost(url, params) {
    var realParam = {
        ...params
    };
    var formParam = new FormData();
    Object.keys(realParam).forEach(item => {
        formParam.append(item, realParam[item]);
    });

    // if (type && type == 'Array') {
    //     realParam = params
    // }
    let config = {
        headers: {
            "Content-Type": "multipart/x-www-form-urlencoded"
        },
        timeout: 60000
    };
    loadingInstance = Loading.service();
    // { responseType: 'blob' }
    return axios
        .post(url, formParam, config)
        .then(reqResult)
        .catch(reqErr);
}

function fiterParams(params) {
    let urlmix = "";
    if (params) {
        let paramstr = "";
        if (typeof params === "string") urlmix = "/" + params;
        if (typeof params === "object") {
            paramstr = qs.stringify(params);
            urlmix = "?" + paramstr;
        }
    }
    return urlmix;
}

function reqResult(res) {
    loadingInstance && loadingInstance.close();

    return res.data;
}

function download(res) {
    loadingInstance && loadingInstance.close();

    let fileName = res.headers["content-disposition"].split("filename=")[1];
    let cleanedFileName = fileName.replaceAll('"', '');

    let blob = new Blob([res.data], {});
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = cleanedFileName;
    link.click();
}

function reqErr(e) {
    let errorHandled = false;

    if (e === ERROR_REDIRECT) {
        errorHandled = true;
    } else if (e && (e.errorMessage || e.msg)) {
        if (e.status === 'LOGIN_OVER_TIMES') {
            e = {
                msg: e.errorMessage,
                status: e.status
            }
        } else {
            e = e.errorMessage || e.msg
        }
    } else {
        e = localization.i18n.t("common.requestFailed");
    }

    loadingInstance && loadingInstance.close();

    throw !errorHandled ? e : "";
}

/*
 * 本地存储
 * set(key,val) 设置给定键名存储
 * get(key) 获取对应键名存储
 * del(key) 删除对应键名存储
 * clear() 清空本地存储
 */
const Storage = {
    set: (key, val) => {
        let b = false,
            valstr = val;
        if (key && key.length > 0) {
            if (typeof val !== "undefined" && val !== null) {
                if (typeof val !== "string") valstr = JSON.stringify(val);
                window.localStorage.setItem(key, valstr);
                b = true;
            }
        }
        return b;
    },
    get: key => {
        let val;
        if (key && key.length > 0) {
            val = window.localStorage.getItem(key);
            try {
                val = JSON.parse(val);
                // eslint-disable-next-line no-empty
            } catch (e) {}
        }
        return val;
    },
    del: key => {
        let b = false;
        if (key && key.length > 0) {
            window.localStorage.removeItem(key);
            b = true;
        }
        return b;
    },
    clear: () => {
        window.localStorage.clear();
    }
};
const SessionStorage = {
    set: (key, val) => {
        let b = false,
            valstr = val;
        if (key && key.length > 0) {
            if (typeof val !== "undefined" && val !== null) {
                if (typeof val !== "string") valstr = JSON.stringify(val);
                window.sessionStorage.setItem(key, valstr);
                b = true;
            }
        }
        return b;
    },
    get: key => {
        let val;
        if (key && key.length > 0) {
            val = window.sessionStorage.getItem(key);
            try {
                val = JSON.parse(val);
                // eslint-disable-next-line no-empty
            } catch (e) {}
        }
        return val;
    },
    remove: key => {
        window.sessionStorage.removeItem(key)
    }
};

function checkFrontendVersion(response) {
    const versionHeader = "x-frontend-version";

    if (!response.headers.hasOwnProperty(versionHeader)) {
        return;
    }

    const currentVersion = store.state.base.version.id;
    const latestVersion = response.headers[versionHeader];

    if (!currentVersion) {
        store.state.base.version.id = latestVersion;
        store.state.base.version.outdated = false;
    } else if (currentVersion !== latestVersion) {
        store.state.base.version.outdated = true;
    }
}

export {
    APP,
    GET,
    POST,
    PUT,
    Delete,
    Storage,
    FormPost,
    SessionStorage
};